import { useCallback } from "react";

import { Stack } from "types/generated";

import useCanManageStack from "./useCanManageStack";

const useCanDisableStack = (): ((stack: Stack) => boolean) => {
  const canManageStack = useCanManageStack();

  return useCallback(
    (stack: Stack) => !stack.isDisabled && canManageStack(stack),
    [canManageStack]
  );
};

export default useCanDisableStack;
